import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import CButton from "../../../../components/buttons/Button";
import CComparePassword from "../../../../components/inputBoxes/comparePassword-input";
import CEmailField from "../../../../components/inputBoxes/email-input";
import COnlyNumberField from "../../../../components/inputBoxes/number-input";
import CPassword from "../../../../components/inputBoxes/password-input";
import CRadiobutton from "../../../../components/inputBoxes/radioButton";
import CTextField from "../../../../components/inputBoxes/text-input";
import CTextAreaField from "../../../../components/inputBoxes/textArea-input";
import { LoadingContext } from "../../../../context/loadingContext";
import {
  createCompanyDetailsHook,
  getCompanyDetailsHook,
  getProfileDetails,
  saveNewPasswordHook,
  updateCompanyDetailsHook,
  UpdatePersonalDetailsHooks,
} from "../hooks/settingsHooks";
import {
  error,
  success,
} from "../../../../components/alertMessagesHandler/alert";
import CDropdownSingleSelect from "../../../../components/dropdown/dropdownSingleSelect";

const DashboardSettings = () => {
  const { setLoading } = useContext(LoadingContext);
  const [profileDetails, setprofileDetails] = useState();
  const [companyDetails, setcompanyDetails] = useState();
  const [firstNameDisable, setFirstNameDisable] = useState(true);
  const [lastNameDisable, setLastNameDisable] = useState(true);
  const [phoneDisable, setPhoneDisable] = useState(true);
  const [changePasswordState, setChangePasswordState] = useState();
  const [changeCompanyState, setChangeCompanyState] = useState();
  const [isCompany, setisCompany] = useState();
  const [personalDetails, setPersonalDetails] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    // Get profile details to autofill using getProfileDetails

    const result = await getProfileDetails();

    // Get company details to autofill using getCompanyDetailsHook

    const companyDetailsHook = await getCompanyDetailsHook();
    setSwitch(companyDetailsHook.data ? companyDetailsHook.data.legal_status : "");
    setcompanyDetails(companyDetailsHook);
    setprofileDetails(result.data);
    setLoading(false);
    if (window.innerWidth <= 992)
      document.getElementById("sidebarToggle").click();
  };

  const setSwitch = (details) => {
    switch (details) {
      case "company":
        document.getElementById("company").checked = true;
        break;
      case "private_person":
        document.getElementById("private_person").checked = true;
        break;
    }
  };

  const HandlePasswordFieldValues = (key, value) => {
    setChangePasswordState({ ...changePasswordState, [key]: value });
  };

  const HandleCompanyFieldValues = (key, value) => {
    setChangeCompanyState({ ...changeCompanyState, [key]: value });
  };

  // Change new password using saveNewPasswordHook

  const savePassword = async () => {
    if (
      changePasswordState.newpassword !== undefined &&
      changePasswordState.newpassword !== ""
    ) {
      setLoading(true);
      const result = await saveNewPasswordHook(changePasswordState);
      setLoading(false);
      if (result.status === 200) success(result.message);
      else error(result.message);
    } else {
      error("Password Mismatch");
    }
  };

  const companySubmit = (event) => {
    event.preventDefault();
    companyDetails.state === 1
      ? updateCompanyDetails()
      : createCompanyDetails();
  };

  // Register company details using createCompanyDetailsHook

  const createCompanyDetails = async () => {
    setLoading(true);
    const result = await createCompanyDetailsHook(changeCompanyState);
    if (result.status === 200) {
      success(result.message);
      getData();
    } else {
      error(result.message);
    }
    setLoading(false);
  };

  // To update company details using updateCompanyDetailsHook

  const updateCompanyDetails = async () => {
    setLoading(true);
    const result = await updateCompanyDetailsHook(changeCompanyState);
    if (result.status === 200) {
      success(result.message);
      getData();
    } else {
      error(result.message);
    }
    setLoading(false);
  };

  // To update personal details using UpdatePersonalDetailsHooks

  const submitPersonalDetails = async () => {
    setLoading(true);
    const result = await UpdatePersonalDetailsHooks(personalDetails);
    setLoading(false);
    if (result.status === 200) success(result.message);
    else error(result.message);
  };
  const handlePersonalDetails = (key, value) => {
    setPersonalDetails({ ...personalDetails, [key]: value });
  };
  return (
    <>
      {profileDetails !== undefined ? (
        <>
          <div className="row mb-2">
            <h4 className="text-dark mb-5 fw-bolder">Settings</h4>
            <h6 className="text-dark mb-4 fw-bolder">Personal Details</h6>
            <div className="col-md-6 col-sm-12">
              <div className="text-dark">
                <FontAwesomeIcon
                  icon={faPencil}
                  className={
                    firstNameDisable === true
                      ? "float-end text-dark"
                      : "float-end text-success"
                  }
                  onClick={() => setFirstNameDisable(false)}
                />
                <CTextField
                  labelName={"First Name"}
                  name={"firstname"}
                  customClassDiv={"mb-4"}
                  customClassInput={"bg-primary-soft"}
                  value={profileDetails.firstname}
                  readOnly={firstNameDisable}
                  functionName={(name, value) =>
                    handlePersonalDetails(name, value)
                  }
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="text-dark">
                <FontAwesomeIcon
                  icon={faPencil}
                  className={
                    lastNameDisable === true
                      ? "float-end text-dark"
                      : "float-end text-success"
                  }
                  onClick={() => setLastNameDisable(false)}
                />
                <CTextField
                  labelName={"Last Name"}
                  name={"lastname"}
                  customClassDiv={"mb-4"}
                  customClassInput={"bg-primary-soft"}
                  readOnly={lastNameDisable}
                  functionName={(name, value) =>
                    handlePersonalDetails(name, value)
                  }
                  value={profileDetails.lastname}
                />
              </div>
            </div>
          </div>

          <div className="row mb-4 text-dark">
            <div className="col-md-6 col-sm-12">
              <div className="text-dark">
                <CEmailField
                  customClassDiv={"mb-4"}
                  customClassInput={"bg-primary-soft"}
                  labelName={"Email"}
                  name={"email"}
                  value={profileDetails.email}
                  readOnly={true}
                />
              </div>
              <div className="mb-4 text-dark">
                <FontAwesomeIcon
                  icon={faPencil}
                  className={
                    phoneDisable === true
                      ? "float-end text-dark"
                      : "float-end text-success"
                  }
                  onClick={() => setPhoneDisable(false)}
                />
                <label className="mb-2">Phone</label>
                <PhoneInput
                  inputProps={{
                    name: "mobile",
                  }}
                  value={profileDetails.mobile}
                  disabled={phoneDisable}
                  country={"kr"}
                  onChange={(phone) => handlePersonalDetails("mobile", phone)}
                />
              </div>
              <CButton
                btnClassesDiv={"text-start"}
                btnClasses={"btn px-4 fw-bold text-white mb-4 mt-4"}
                IsOutline={false}
                innertext={"Update Changes"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
                functionName={() => submitPersonalDetails()}
              />
            </div>
            <div className="col-6"></div>
          </div>

          <div className="row mb-4 text-dark">
            <h6 className="mb-3 fw-bolder">Account Details</h6>
            <div className="col-md-6 col-sm-12">
              <CPassword
                labelName={"Existing Password"}
                name={"password"}
                customClassDiv={"mb-3"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, value) =>
                  HandlePasswordFieldValues(name, value)
                }
              />
            </div>
            <div className="col-6"></div>
            <CComparePassword
              labelName1={"New Password"}
              name1={"newpassword"}
              labelName2={"Confirm New Password"}
              name2={"confirmpassword"}
              customClassInput={"bg-primary-soft"}
              customClassRowDiv={"mb-4"}
              functionName={(name, value) =>
                HandlePasswordFieldValues(name, value)
              }
            />
          </div>
          <CButton
            btnClassesDiv={"text-start mb-5"}
            btnClasses={"btn px-4 fw-bold text-white"}
            IsOutline={false}
            innertext={"Update Password"}
            btnCustomStyle={{
              backgroundColor: "#044389",
            }}
            functionName={() => savePassword()}
          />
        </>
      ) : (
        <></>
      )}
      <form onSubmit={companySubmit}>
        <div className="row mb-4 text-dark">
          <h6 className="fw-bold mb-4">Company Details</h6>
          <div className="col-md-6 col-sm-12">
            <CRadiobutton
              labelName={"Legal Status"}
              customClassDiv={"mb-4 text-dark"}
              isInline={true}
              choiceListArray={[
                { id: "company", value: "company", label: "Company" },
                {
                  id: "private_person",
                  value: "private_person",
                  label: "Private Person",
                },
              ]}
              defaultcheckedValue={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.legal_status
                  : ""
              }
              customClassLabel={"mb-3"}
              name={"legal_status"}
              functionName={(name, value) => {
                value === "company" ? setisCompany(true) : setisCompany(false);
                HandleCompanyFieldValues(name, value);
              }}
            />
            <CDropdownSingleSelect
              labelName={"Country"}
              name={"country"}
              placeholder={"country"}
              customClassDiv={"text-dark mb-4"}
              customClassSelect={"bg-primary-soft text-muted"}
              choiceListArray={[
                { value: "us", label: "US" },
                { value: "uk", label: "UK" },
              ]}
              defaultValue={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.country
                  : ""
              }
              functionName={(name, value) =>
                HandleCompanyFieldValues(name, value)
              }
            />
            {companyDetails !== undefined &&
              companyDetails.data !== undefined &&
              companyDetails.data.legal_status === "company" ? (
              <CTextField
                labelName={"Company Name"}
                required={true}
                name={"company_name"}
                customClassDiv={"mb-3 text-dark"}
                customClassInput={"bg-primary-soft"}
                value={
                  companyDetails !== undefined &&
                    companyDetails.data !== undefined
                    ? companyDetails.data.company_name
                    : ""
                }
                functionName={(name, value) =>
                  HandleCompanyFieldValues(name, value)
                }
              />
            ) : isCompany ? (
              <CTextField
                labelName={"Company Name"}
                required={true}
                name={"company_name"}
                customClassDiv={"mb-3 text-dark"}
                customClassInput={"bg-primary-soft"}
                value={
                  companyDetails !== undefined &&
                    companyDetails.data !== undefined
                    ? companyDetails.data.company_name
                    : ""
                }
                functionName={(name, value) =>
                  HandleCompanyFieldValues(name, value)
                }
              />
            ) : (
              <></>
            )}

            <CTextField
              labelName={"City"}
              required={true}
              name={"city"}
              value={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.city
                  : ""
              }
              customClassDiv={"mb-3 text-dark"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) =>
                HandleCompanyFieldValues(name, value)
              }
            />
            <COnlyNumberField
              labelName={"Postal Code"}
              required={true}
              name={"postal_code"}
              pattern={"[0-9]+?"}
              value={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.postal_code
                  : ""
              }
              customClassDiv={"mb-3 text-dark"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) =>
                HandleCompanyFieldValues(name, value)
              }
            />
            <CTextAreaField
              labelName={"Address"}
              rowsTextArea={1}
              name={"address"}
              value={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.address
                  : ""
              }
              customClassDiv={"mb-3 text-dark"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) =>
                HandleCompanyFieldValues(name, value)
              }
            />
            <COnlyNumberField
              labelName={"Tax Identification Number"}
              customClassDiv={"mb-5 text-dark"}
              name={"tax_identification_number"}
              pattern={"[a-zA-Z0-9]+?"}
              value={
                companyDetails !== undefined &&
                  companyDetails.data !== undefined
                  ? companyDetails.data.tax_identification_number
                  : ""
              }
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) =>
                HandleCompanyFieldValues(name, value)
              }
            />
            <CButton
              btnClassesDiv={"text-start mb-4"}
              btnClasses={"btn px-4 fw-bold text-white"}
              IsOutline={false}
              innertext={"Update Details"}
              btnCustomStyle={{
                backgroundColor: "#044389",
              }}
            />
          </div>
          <div className="col-md-2 col-sm-12"></div>
          <div className="col-md-4 col-sm-12 mt-5">
            <div className="mt-5">
              <p className="fw-bold">Email Notification for Publisher</p>
              <p className="mb-0">Change in portal status</p>
              <p className="mb-0">
                New Matching guest articles for publication
              </p>
              <p>SMS notification about delays</p>
              <p className="fw-bold">Email Notification for Publisher</p>
              <p className="mb-0">Change in guest article status</p>
              <p className="mb-0">Change sponsored article status</p>
              <p className="mb-0">Request for guest articles</p>
              <p className="mb-0">
                Change the status of the brief and proposals for influencers
              </p>
              <p>Generation statistics for the project</p>
            </div>
          </div>
        </div>
      </form>

      {/* <div className="row mb-4 text-dark">
        <h6 className="fw-bold mb-3">Language and Currency</h6>
        <div className="col-md-6 col-sm-12">
          <CTextField
            labelName={"Your Country (Residency)"}
            required={true}
            customClassDiv={"mb-3"}
            customClassInput={"bg-primary-soft"}
          />
          <p>Operation Currency : USD</p>
          <p>Preview Currency : USD</p>
        </div>
        <div className="col-6"></div>
      </div> */}
      {/* <div className="row mb-5 text-dark">
        <h6 className="fw-bold mb-3">Accounting Notification Settings</h6>
        <div className="col-md-6 col-sm-12">
          <CEmailField
            labelName={"Send Invoices Additionally to"}
            customClassDiv={"mb-3"}
            customClassInput={"bg-primary-soft"}
          />
          <h6 className="fw-bold mb-3">Email Notification</h6>
          <br></br>
          <p>What to add here?</p>
        </div>
        <div className="col-6"></div>
      </div>{" "} */}
    </>
  );
};

export default DashboardSettings;
